module.exports = __webpack_public_path__ + "static/media/limeBg.ebedde95.jpg";